import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'imageUrl' })
export class ImageUrlPipe implements PipeTransform {
  transform(image: any): string {
    const imageUrl = image && (image['secureUrl'] || image['url'])
    return imageUrl.replace('http:', 'https:')
  }
}
